<div class="profile-container" *ngIf="!editProduct">
    <div class="">
        <div class="profile-content">
            <div class="personal-details">
                <h4 class="personal-details-title">UPDATE PRODUCT</h4>
                <table class="table table-striped">
                  <thead>
                    <tr>
                      <th scope="col">#</th>
                      <th scope="col">Name</th>
                      <th scope="col">Description</th>
                      <th scope="col">Group</th>
                      <th scope="col">Code</th>
                    
                      <th scope="col">Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let x of product | paginate : {
                        itemsPerPage: tableSize,
                        currentPage: pageNumber,
                        totalItems: totalRecords
                      };let i = index">
                      <th scope="col">{{x.productMasterId}}</th>
                      <th scope="col">{{x.name}}</th>
                      <th scope="col">{{x.description}}</th>
                      <th scope="col">{{x.group}}</th>
                      <th scope="col">{{x.code | number}}</th>
            
                      <th>
                        <svg (click)="getProductById(x.productMasterId)" data-toggle="modal" data-target="#updateModal" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-pencil-square" viewBox="0 0 16 16">
                          <path d="M15.502 1.94a.5.5 0 0 1 0 .706L14.459 3.69l-2-2L13.502.646a.5.5 0 0 1 .707 0l1.293 1.293zm-1.75 2.456-2-2L4.939 9.21a.5.5 0 0 0-.121.196l-.805 2.414a.25.25 0 0 0 .316.316l2.414-.805a.5.5 0 0 0 .196-.12l6.813-6.814z"/>
                          <path fill-rule="evenodd" d="M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 0 1 2.5v11z"/>
                        </svg>
                      </th>
                    </tr>
                  </tbody>
              </table>
              <div class="pagination-block" *ngIf="product.length != 0">
                <pagination-controls
                previousLabel="Prev"
                nextLabel="Next"
                (pageChange)="onTableDataChange($event)"
                >
                </pagination-controls>
              </div>
            </div>
  
        </div>
    </div>
</div>



<div class="profile-container" *ngIf="editProduct">
  <div class="">
      <div class="profile-content">
          <div class="personal-details">
              <h4 class="personal-details-title">Update Product</h4>
              <div [formGroup]="form">
                  <div class="form-group">
                      <label>Product Name</label>
                      <input formControlName="name" type="text" class="form-control">
                  </div>
                  <div class="form-group">
                      <label>Product Description</label>
                      <input formControlName="description" type="text" class="form-control">
                  </div>
                  <div class="form-group">
                      <label>Product Group</label>
                      <input formControlName="group" type="text" class="form-control">
                  </div>
                  <div class="form-group">
                      <label>Product Code</label>
                      <input formControlName="code" type="number" class="form-control">
                  </div>
                  <div class="form-group ">
                    <label>Select UOMs</label>
                    <ng-multiselect-dropdown
                    [placeholder]="'select uoms'"
                    [settings]="uomDropdownSettings"
                    [data]="uomDropdownList"
                    [(ngModel)]="uomSelectedList"
                    class="form-control"
                    style="padding: 0;border: none"
                    [ngModelOptions]="{standalone: true}"
                    (onSelect)="onItemSelect($event)"
                    (onSelectAll)="onSelectAll($event)"
                    >
                    </ng-multiselect-dropdown>
                  </div>

                  <div class="form-group" >
                      <div class=" row" >
                          <div class="items-b col-md-6 col-lg-6" *ngFor="let item of uomSelectedList1;let i = index">
                              <div class="example-box" >
                                  <div class="row input-data">
                                      <div class="col-md-4 col-lg-4">
                                          <label for="">Uom Name:</label>
                                          <input type="text" [ngModelOptions]="{standalone: true}" readonly [(ngModel)]="item.uomName" class="form-control">
                                      </div>
                                      <div class="col-md-4 col-lg-4">
                                          <label for="">Color:</label>
                                          <input type="text" [ngModelOptions]="{standalone: true}" [(ngModel)]="item.color" class="form-control">
                                      </div>
                                      <div class="col-md-4 col-lg-4">
                                          <label for="">Currency:</label>
                                          <select name="" id="" [ngModelOptions]="{standalone: true}" (change)="currencyChanged(item.currencyType,i)" [(ngModel)]="item.currencyType" class="form-control">
                                              <option  [value]="currency.currencyName" *ngFor="let currency of currencyType">{{currency.currencyName}} - {{currency.currencySymbol}}</option>
                                          </select>
                                      </div>
                                      <div class="col-md-4 col-lg-4">
                                          <label for="">Quantity:</label>
                                          <input type="number" [ngModelOptions]="{standalone: true}" [(ngModel)]="item.quantity" class="form-control">
                                      </div>
                                      <div class="col-md-4 col-lg-4">
                                          <label for="">Price:</label>
                                          <input type="number" [ngModelOptions]="{standalone: true}" [(ngModel)]="item.price" class="form-control">
                                      </div>
                                      <div class="col-md-4 col-lg-4">
                                          <label for="">Discounted Price:</label>
                                          <input type="number" [ngModelOptions]="{standalone: true}" [(ngModel)]="item.discountedPrice" class="form-control">
                                      </div>
                                      <div class="col-md-4 col-lg-4">
                                          <label for="">Min Quantity:</label>
                                          <input type="number" [ngModelOptions]="{standalone: true}" [(ngModel)]="item.minOrderQuantity" class="form-control">
                                      </div>
                                      <div class="col-md-4 col-lg-4">
                                          <label for="">Max Quantity :</label>
                                          <input type="number" [ngModelOptions]="{standalone: true}" [(ngModel)]="item.maxOrderQuantity" class="form-control">
                                      </div>
                                  </div>
                              </div>
                          </div>
                      </div>
                  </div>
                
                  <div class="form-group">
                      <label>Select Default UOM</label>
                      <select class="form-control" [ngModelOptions]="{standalone: true}" [(ngModel)]="isDefault">
                          <option value="" disabled selected hidden>-- select default uom --</option>
                          <option *ngFor="let uom of uomSelectedList" [value]="uom.uomMasterId">{{uom.uomName}}</option>
                      </select>
                  </div>
                  <div class="form-group" *ngFor="let list of keyValueList">
                      <label>{{list.key}}</label>
                      <input type="text" class="form-control" *ngIf="list.possibleValue.length == 0" [ngModelOptions]="{standalone: true}" [(ngModel)]="list.value">
                      <select class="form-control" *ngIf="list.possibleValue.length != 0" [ngModelOptions]="{standalone: true}" [(ngModel)]="list.value">
                          <option *ngFor="let possibleValue of list.possibleValue" [value]="possibleValue">{{possibleValue}}</option>
                      </select>
                  </div>

                  <div class="form-group">
                      <label>Specifications</label>
                      <div class="specifications-block">
                          <div class="specifications-data" *ngFor="let specification of productSpecifications;let i = index;let first = first;let last = last;">
                              <input [ngModelOptions]="{standalone: true}" type="text" class="" placeholder="enter key" [(ngModel)]="specification.key">
                              <textarea [ngModelOptions]="{standalone: true}" name="" id="" cols="30" class="" placeholder="enter value" [(ngModel)]="specification.value" rows="10"></textarea>
                              <span><i class="bi bi-plus-circle" (click)="addProductSpecifications()"></i><i class="bi bi-dash-circle" *ngIf="!first && i != 0" (click)="removeProductSpecifications(i)"></i></span>
                          </div>
                      </div>
                  </div>

                  <div class="form-group">
                      <label>Product Version</label>
                      <select formControlName="version" class="form-control" name="" id="">
                          <option value="1">version 1</option>
                          <option value="2">version 2</option>
                      </select>
                  </div>

                  <div class="">
                      <div class="form-group image-b" *ngIf="form.controls['image'].value == ''">
                          <label>Default Image </label>
                          <button class="" (click)="imageButtonClick()">Add Image</button>
                          <input type="file" id="imageInput" (change)="onChange($event)" accept="image/*" [style.display]="'none'">
                      </div>
                      <div class="form-group image-view" *ngIf="form.controls['image'].value != ''">
                          <label>Default Image </label>
                          <img [src]="form.controls['image'].value" alt="" srcset="">
                          <button class="btn btn-secondary" (click)="imageRemove()">Remove</button>
                      </div>
                  </div>

                  <div class="">
                      <div class="form-group image-b">
                          <label>Image List</label>
                          <button class="" (click)="imageListButtonClick()">Add Image</button>
                          <input type="file" id="imageListInput" (change)="onListChange($event)" accept="image/*" [style.display]="'none'">
                      </div>
                      <div class="form-group image-view-list row" *ngIf="imageUrlList.length != 0">
                          <div class="col-md-2 col-lg-2" *ngFor="let image of imageUrlList;let i = index">
                              <img [src]="image" alt="" srcset="">
                              <i class="bi bi-x-lg" (click)="imageListRemove(i)"></i>
                          </div>
                      </div>
                  </div>

                  <div class="form-group">
                      <label>Select Vendors</label>
                      <ng-multiselect-dropdown
                          [placeholder]="'select vendors'"
                          [settings]="vendorMastersDropdownSettings"
                          [data]="vendorMastersDropdownList"
                          [(ngModel)]="vendorMastersSelectedList"
                          class="form-control" [ngModelOptions]="{standalone: true}"
                          style="padding: 0;border: none"
                          (onSelect)="vendorSelect($event)"
                          (onDeSelect)="onDeSelectVendor($event)"
                          >
                      </ng-multiselect-dropdown>
                  </div>

                  <div class="form-group">
                      <label>Select Related Products</label>
                      <ng-multiselect-dropdown
                          [placeholder]="'select related products'"
                          [settings]="relatedProductDropdownSettings"
                          [data]="relatedProductDropdownList"
                          [(ngModel)]="relatedProductSelectedList"
                          class="form-control" [ngModelOptions]="{standalone: true}"
                          style="padding: 0;border: none"
                          (onSelect)="onRelatedProductSelect($event)"
                          (onDeSelect)="onDeSelect($event)"
                          >
                      </ng-multiselect-dropdown>
                  </div>
                  <div class="form-group product-view-list row" *ngIf="relatedProductList.length != 0">
                      <div class="col-md-2 col-lg-2" *ngFor="let product of relatedProductList;let i = index">
                          <div class="product-view-detail">
                              <img [src]="product.imageUrl" alt="" srcset="">
                              <p>{{ product.name }}</p>
                          </div>
                      </div>
                  </div>

                  <div class="form-group">
                      <label>Select Similar Products</label>
                      <ng-multiselect-dropdown
                          [placeholder]="'select similar products'"
                          [settings]="similarProductDropdownSettings"
                          [data]="similarProductDropdownList"
                          [(ngModel)]="similarProductSelectedList"
                          class="form-control" [ngModelOptions]="{standalone: true}"
                          style="padding: 0;border: none"
                          (onSelect)="onSimilarProductSelect($event)"
                          (onDeSelect)="onDeSelectSimilar($event)"
                          >
                      </ng-multiselect-dropdown>
                  </div>
                  <div class="form-group product-view-list row" *ngIf="similarProductList.length != 0">
                      <div class="col-md-2 col-lg-2" *ngFor="let product of similarProductList;let i = index">
                          <div class="product-view-detail">
                              <img [src]="product.imageUrl" alt="" srcset="">
                              <p>{{ product.name }}</p>
                          </div>
                      </div>
                  </div>

                  <div class="form-group">
                      <label>Tax Info </label>
                      <ng-multiselect-dropdown
                          [placeholder]="'select tax info'"
                          [settings]="taxInfoDropdownSettings"
                          [data]="taxInfoDropdownList"
                          [(ngModel)]="taxInfoSelectedList"
                          class="form-control" [ngModelOptions]="{standalone: true}"
                          style="padding: 0;border: none"
                          (onSelect)="onTaxInfoSelect($event)"
                          (onDeSelect)="onDeSelectTaxMaster($event)"
                          >
                      </ng-multiselect-dropdown>
                  </div>

                  <div class="form-group">
                      <label>Sku</label>
                      <input formControlName="sku" type="text" class="form-control">
                  </div>

                  <div class="form-group">
                      <label for="">Product Sale Type</label>
                      <div class="productSaleType-list">
                          <div *ngFor="let type of productSaleTypeList;let i = index">
                              <input type="checkbox" [(ngModel)]="type.isChecked" [ngModelOptions]="{standalone: true}">
                              <label for="">{{type.type}}</label>
                          </div>
                      </div>
                  </div>

                  <div class="form-group">
                      <label>Tags</label>
                      <div class="tags-block">
                          <div class="tags-data" *ngFor="let tag of tags;let i = index;let first = first;let last = last;">
                              <input [ngModelOptions]="{standalone: true}" type="text" class="" placeholder="enter tag" [(ngModel)]="tag.key">
                              <span><i class="bi bi-plus-circle" (click)="addTags()"></i><i class="bi bi-dash-circle" *ngIf="!first && i != 0" (click)="removeTags(i)"></i></span>
                          </div>
                      </div>
                  </div>
              </div>
              <div class="modal-footer">
                  <button type="button" id="closeModalButton" class="btn btn-secondary" (click)="closeEdit()">Cancel</button>
                  <button type="button" (click)="updateProduct()" class="btn btn-primary">Update</button>
              </div>
          </div>
      </div>
  </div>
</div>